export default __webpack_public_path__ + "static/media/hualien-coast.924e54c4.jpg";